module.exports = __webpack_public_path__ + "img/icon-qd.0c305fc8.svg";